// src/components/NotificationBar.tsx
import React from "react";
import dayjs from "dayjs";

// Define border colors based on title or status (customize as needed)

interface CriticalEventsCardProps {
  title: string;
  timeAgo: string;
  details: string;
  lastStatus: string;
}

const CriticalEventsCard: React.FC<CriticalEventsCardProps> = ({
  title,
  timeAgo,
  details,
  lastStatus,
}) => {
  return (
    <div className={`w-full max-w-md !bg-[var(--bg-elevated)] rounded-xl p-3 flex items-start space-x-2 border-t border-r border-b border-[var(--border-default)] border-l-4 border-l-[var(--border-critical)]`}>
      {/* Icon */}
      <div className="flex-shrink-0 w-10 h-10 rounded-md bg-[var(--bg-icon-muted)] flex items-center justify-center overflow-hidden">
        <i className="fa fa-bolt text-[var(--text-primary)] text-lg" />
      </div>

      {/* Content */}
      <div className="flex-1">
        <div className="flex justify-between items-start mb-1">
          <div>
            <h4 className="text-[13px] font-semibold">{title}</h4>
            <div className="text-[var(--text-tertiary)] text-[10px]">{details}</div>
            <div className="text-[11px] mt-1">Last status: <span className="last-status" style={{ color: 'var(--status-info)' }}>{dayjs(lastStatus).format("MMM D, YYYY h:mm A")}</span></div>
          </div>

          <div style={{ marginLeft: 12, textAlign: 'right' }}>
            <div className="last-status" style={{ fontSize: 12, color: 'var(--status-info)' }}>{timeAgo}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CriticalEventsCard;
